import React from 'react';
import { CHAR_LIMIT } from './constants';
import styles from './Footer.module.scss';

const TextCounterWithHelp = ({ hasExceededLimit, valueLength }) => {
  return (
    <span className={styles.helpContainer}>
      {hasExceededLimit && 'Превышен лимит допустимого количества символов'}
      <span className={styles.textCounter}>
        {valueLength || 0}/{CHAR_LIMIT}
      </span>
    </span>
  );
};

export default TextCounterWithHelp;
